/**
 * RISK-FAMILY.STORE.TS
 */
import { createEntityStore } from "@/core/factory/store"
import { createEmptyRiskFamily, RISK_FAMILY_ENTITY, RiskFamily } from "./risk-family.types"
import { noContext } from "@/core/utils/noContext"

const createRiskFamilyStore = () => {
  return createEntityStore<RiskFamily, null>(RISK_FAMILY_ENTITY, createEmptyRiskFamily, noContext)
}

const riskFamilyStore = createRiskFamilyStore()
export default riskFamilyStore
